export default {
  showModal: true,
  maxSessions: 15,
  activeSessionsHours: 12,
  gaTrackerId: 'UA-45281033-8',
  // Customers Ids who shouldn't get sessions limit modal window, provided by PM https://gitlab.delfi.net/home/issues/-/issues/2021#note_394753
  allowedCustomersIds: [223846, 1297811, 949755],
};
